module.exports = __webpack_public_path__ + "static/media/Patient.06cde2b1.png";